import React from "react";
 
import { Helmet } from "react-helmet";
function Privacy(){
return(
<div >


<Helmet>
 
<title>Codeexampler Privacy Policy</title>
<meta name="description" content="Codeexampler Privacy Policy.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and  questions of all technology like java tutorial, python tutorial,c# tutorial for beginners in deeply knowledge " />
<link rel="canonical" href="https://www.codeexampler.com/privacy-policy" />
</Helmet>



<div className="ml-4">
<h1>Privacy Policy for codeexampler</h1>

<p className="mt-4">codeexampler &copy;{new Date().getFullYear()} All Rights Reserved.All Content on  <a href="https://www.codeexampler.com/">codeexampler</a>  is Protected By Copyright.Do Not Copy or Republish.</p>


<p className="mt-4">you may not redistribute and modify,publish,reproduce,sell,create derivative works or commercially exploit our content without prior written consent.If wanting to feature an article,you may quote a short snippet form the post wich must link back to the original post on <a href="https://www.codeexampler.com/">codeexampler</a>. you may not post the entire blog post and tutorials,code or any written material,without prior permission</p>


<h2 className="mt-4 bold">Use of Cookies</h2>

<p className="mt-4">This website uses cookies to better the users experience while visiting the website. Where applicable this website uses a cookie control system allowing the user on their first visit to the website to allow or disallow the use of cookies on their computer / device. This complies with recent legislation requirements for websites to obtain explicit consent from users before leaving behind or reading files such as cookies on a user's computer / device.<br/><br/>

This website uses tracking software to monitor its visitors to better understand how they use it. This software is provided by Google Analytics which uses cookies to track visitor usage. The software will save a cookie to your computers hard drive in order to track and monitor your engagement and usage of the website, but will not store, save or collect personal information. You can read Google's privacy policy here for further information https://www.google.com/privacy.html<br/><br/>

Other cookies may be stored to your computers hard drive by external vendors when this website uses referral programs, sponsored links or adverts. Such cookies are used for conversion and referral tracking and typically expire after 30 days, though some may take longer. No personal information is stored, saved or collected.<br/>

</p>


<h1 className="mt-4 bold">External Links</h1>

<p className="mt-4">Although this website only looks to include quality, safe and relevant external links, users are advised adopt a policy of caution before clicking any external web links mentioned throughout this website. (External links are clickable text / banner / image links to other websites.<br/>

The owners of this website cannot guarantee or verify the contents of any externally linked website despite their best efforts. Users should therefore note they click on external links at their own risk and this website and its owners cannot be held liable for any damages or implications caused by visiting any external links mentioned.<br/>

</p>

<h1 className="mt-4">Adverts and Sponsored Links</h1>

<p className="mt-4">This website may contain sponsored links and adverts. These will typically be served through our advertising partners, to whom may have detailed privacy policies relating directly to the adverts they serve.<br/>

Clicking on any such adverts will send you to the advertisers website through a referral program which may use cookies and will track the number of referrals sent from this website. This may include the use of cookies which may in turn be saved on your computers hard drive. Users should therefore note they click on sponsored external links at their own risk and this website and its owners cannot be held liable for any damages or implications caused by visiting any external links mentioned </p>


<h1 className="mt-4">Social Media Platforms</h1>

<p className="mt-4">Communication, engagement and actions taken through external social media platforms that this website and its owners participate on are custom to the terms and conditions as well as the privacy policies held with each social media platform respectively.<br/>

Users are advised to use social media platforms wisely and communicate / engage upon them with due care and caution in regard to their own privacy and personal details. This website nor its owners will ever ask for personal or sensitive information through social media platforms and encourage users wishing to discuss sensitive details to contact them through primary communication channels such as by telephone or email.<br/>

This website may use social sharing buttons which help share web content directly from web pages to the social media platform in question. Users are advised before using such social sharing buttons that they do so at their own discretion and note that the social media platform may track and save your request to share a web page respectively through your social media platform account.<br/>
</p>














</div>


    <h1 className="mt-5"> </h1>
    
    </div>


)

}
export default Privacy;